var map = {
	"./add-event2.svg": 15119,
	"./add.svg": 44144,
	"./agent-avg-earnings.svg": 28735,
	"./all-icon.svg": 20194,
	"./answered-calls.svg": 94634,
	"./apple.svg": 1433,
	"./appointments-icon.svg": 41689,
	"./asana.svg": 57435,
	"./attendance-today.svg": 44702,
	"./average-order-value-icon.svg": 42703,
	"./bar-code.svg": 44312,
	"./beauty-icon.svg": 99323,
	"./behance.svg": 28725,
	"./boys.svg": 44154,
	"./brazil.svg": 87825,
	"./canada.svg": 82029,
	"./card.svg": 2505,
	"./cash.svg": 82642,
	"./check-in-desk.svg": 32275,
	"./check.svg": 96729,
	"./chevron-left.svg": 70694,
	"./chevron-right.svg": 20549,
	"./clothing-icon.svg": 39095,
	"./clothing-icon2.svg": 47927,
	"./debit.svg": 7707,
	"./dog.svg": 69847,
	"./down-white.svg": 32979,
	"./down.svg": 51603,
	"./down2.svg": 66763,
	"./dribbble-real.svg": 9938,
	"./dribbble.svg": 56525,
	"./dribbble2.svg": 54469,
	"./e-wallet.svg": 96602,
	"./earnings-icon.svg": 47312,
	"./electronics-icon.svg": 56925,
	"./electronics-icon2.svg": 9012,
	"./facebook-real.svg": 53716,
	"./facebook.svg": 97103,
	"./facebook2.svg": 69919,
	"./facebook3.svg": 55278,
	"./facebook4.svg": 66833,
	"./figma-real.svg": 53330,
	"./figma.svg": 17453,
	"./flags/australia.svg": 60043,
	"./flags/brazil.svg": 9837,
	"./flags/canada.svg": 4257,
	"./flags/france.svg": 45822,
	"./flags/germany.svg": 58290,
	"./flags/portugal.svg": 11437,
	"./flags/spain.svg": 35762,
	"./flags/uk.svg": 78723,
	"./flags/usa.svg": 41776,
	"./foods-icon.svg": 75360,
	"./france.svg": 14098,
	"./gdrive.svg": 21098,
	"./germany.svg": 94918,
	"./girls.svg": 12444,
	"./git.svg": 67173,
	"./github.svg": 23322,
	"./google-real.svg": 90215,
	"./google.svg": 16598,
	"./google2.svg": 79096,
	"./google3.svg": 30313,
	"./home-goods-icon.svg": 72447,
	"./icon-employees.svg": 35816,
	"./icon-resigned.svg": 75458,
	"./icon-salary-paid.svg": 87246,
	"./icon-salary-pending.svg": 72085,
	"./icon-total-payroll.svg": 99013,
	"./icons/4dot.svg": 67631,
	"./icons/4dot2.svg": 55615,
	"./icons/4dot3.svg": 40974,
	"./icons/add-event.svg": 95080,
	"./icons/apple.svg": 66694,
	"./icons/ball.svg": 98701,
	"./icons/behance.svg": 96486,
	"./icons/boys.svg": 59691,
	"./icons/call.svg": 98478,
	"./icons/call2.svg": 70432,
	"./icons/call3.svg": 27345,
	"./icons/call4.svg": 45518,
	"./icons/call5.svg": 83455,
	"./icons/call6.svg": 20780,
	"./icons/call7.svg": 56237,
	"./icons/call8.svg": 30490,
	"./icons/call9.svg": 35755,
	"./icons/celebration.svg": 18214,
	"./icons/chart.svg": 39038,
	"./icons/check-cart.svg": 28185,
	"./icons/clothing.svg": 10454,
	"./icons/container.svg": 39447,
	"./icons/crown.svg": 80747,
	"./icons/data.svg": 85514,
	"./icons/dog.svg": 28844,
	"./icons/dollar-bag.svg": 23905,
	"./icons/done.svg": 71154,
	"./icons/dot-menu.svg": 74653,
	"./icons/dribbble.svg": 74548,
	"./icons/dribbble2.svg": 84078,
	"./icons/email.svg": 30582,
	"./icons/examination.svg": 49497,
	"./icons/face.svg": 41189,
	"./icons/facebook.svg": 52542,
	"./icons/facebook2.svg": 15280,
	"./icons/facebook3.svg": 27521,
	"./icons/facebook4.svg": 2238,
	"./icons/figma.svg": 86130,
	"./icons/figma2.svg": 40588,
	"./icons/file-download.svg": 93737,
	"./icons/food.svg": 90426,
	"./icons/gif.svg": 41536,
	"./icons/gift-card.svg": 35727,
	"./icons/girls.svg": 89843,
	"./icons/gitlab.svg": 24039,
	"./icons/google-drive.svg": 42800,
	"./icons/google.svg": 15583,
	"./icons/google2.svg": 99151,
	"./icons/google3.svg": 20222,
	"./icons/graduation.svg": 80118,
	"./icons/gross-earnings.svg": 482,
	"./icons/hair-cutting.svg": 2725,
	"./icons/instagram.svg": 91690,
	"./icons/instagram2.svg": 9748,
	"./icons/instagram3.svg": 31381,
	"./icons/linkedin.svg": 96620,
	"./icons/linkedin2.svg": 86838,
	"./icons/linkedin3.svg": 50055,
	"./icons/manicure.svg": 17964,
	"./icons/map.svg": 9352,
	"./icons/money-bag.svg": 37839,
	"./icons/money.svg": 28762,
	"./icons/nail-polish.svg": 55064,
	"./icons/not-done.svg": 54678,
	"./icons/note.svg": 10886,
	"./icons/pedicure.svg": 59889,
	"./icons/pinterest.svg": 42480,
	"./icons/salary-paid.svg": 78155,
	"./icons/salary-pending.svg": 66882,
	"./icons/schedule.svg": 79961,
	"./icons/scissors.svg": 52895,
	"./icons/slack.svg": 12770,
	"./icons/spotify.svg": 71232,
	"./icons/star-popular.svg": 78830,
	"./icons/star.svg": 35034,
	"./icons/student.svg": 53247,
	"./icons/supabase.svg": 52628,
	"./icons/teacher.svg": 12560,
	"./icons/tiktok.svg": 44300,
	"./icons/total-balance.svg": 24751,
	"./icons/total-payroll.svg": 28464,
	"./icons/transactions.svg": 83753,
	"./icons/trello.svg": 43684,
	"./icons/verified.svg": 11194,
	"./icons/video-chat.svg": 52274,
	"./icons/woman.svg": 87480,
	"./icons/x.svg": 48830,
	"./icons/youtube.svg": 67921,
	"./inbound-calls.svg": 43882,
	"./instagram-real.svg": 5466,
	"./instagram.svg": 66149,
	"./instagram2.svg": 1165,
	"./landing/logo.svg": 7134,
	"./linkedin.svg": 39705,
	"./linkedin2.svg": 16297,
	"./logo-white.svg": 27270,
	"./logo.svg": 3914,
	"./mailchimp.svg": 423,
	"./map.svg": 54495,
	"./message.svg": 31840,
	"./missed-calls.svg": 18944,
	"./new-customers-icon.svg": 20279,
	"./new-employees.svg": 56251,
	"./notice-board-icon-1.svg": 25832,
	"./notice-board-icon-2.svg": 60219,
	"./notice-board-icon-3.svg": 99850,
	"./notice-board-icon-4.svg": 23061,
	"./operations-icon.svg": 5005,
	"./outbound-calls.svg": 73591,
	"./patients-icon.svg": 39693,
	"./payment-method/bank.svg": 65020,
	"./payment-method/paypal.svg": 96035,
	"./payment-method/skrill.svg": 87783,
	"./payment-method/wise.svg": 358,
	"./pinterest.svg": 70975,
	"./point.svg": 33279,
	"./popular.svg": 92078,
	"./portugal.svg": 90497,
	"./qr-code.svg": 14512,
	"./remove.svg": 53747,
	"./returning-customers-icon.svg": 95047,
	"./sales-over-time-icon.svg": 47940,
	"./schedule.svg": 21496,
	"./signature.svg": 47003,
	"./slack.svg": 34809,
	"./slak.svg": 43046,
	"./spain.svg": 30078,
	"./spotify.svg": 46355,
	"./total-calls.svg": 32551,
	"./total-discount-icon.svg": 72993,
	"./total-sales-icon.svg": 55390,
	"./total-students.svg": 10780,
	"./total-teachers.svg": 55113,
	"./total-transactions-icon.svg": 39155,
	"./trello.svg": 20401,
	"./twitter.svg": 76072,
	"./united-kingdom.svg": 24502,
	"./usa.svg": 36492,
	"./verify-2.svg": 69789,
	"./verify-3.svg": 41244,
	"./verify-border.svg": 80427,
	"./verify.svg": 96016,
	"./virtual.svg": 41880,
	"./white-logo.svg": 61958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;